import type { ReactNode } from 'react';

import { DateHeure } from '../../composants/communs.tsx';
import { Icone } from '../../composants/icones.tsx';
import type { DetailVente } from './types.ts';

/** Bandeau d'infos — date, boutique, vendeur, client, canal. */
export function InfoBarre({ vente }: { vente: DetailVente }): ReactNode {
  const client =
    vente.client_nom === null || vente.client_nom === undefined
      ? 'Divers'
      : `${vente.client_prenom ?? ''} ${vente.client_nom}`.trim();

  const infos: { icone: Parameters<typeof Icone>[0]['nom']; libelle: string; valeur: string }[] = [
    { icone: 'calendrier', libelle: 'Date', valeur: '' },
    { icone: 'boutiques', libelle: 'Boutique', valeur: vente.boutique },
    { icone: 'personne', libelle: 'Vendeur', valeur: vente.vendeur },
    { icone: 'clients', libelle: 'Client', valeur: client },
    { icone: 'ventes', libelle: 'Canal', valeur: vente.canal },
  ];

  return (
    <section aria-label="Informations de la vente" className="vente-section fiche-info-grille">
      {infos.map((info) => (
        <div key={info.libelle} className="fiche-info">
          <span className="fiche-info__icone">
            <Icone nom={info.icone} taille={18} />
          </span>
          <div>
            <div className="fiche-info__libelle">{info.libelle}</div>
            <div className="fiche-info__valeur">
              {info.libelle === 'Date' ? <DateHeure valeur={vente.horodatage_serveur} /> : info.valeur}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
